import * as React from "react";

import {GlobalToaster} from "../../organisms/global-toaster/global-toaster";
import {BasicLayout} from "../basic-layout/basic-layout";

type GuestLayoutProps = React.PropsWithChildren<{}>;

export const GuestLayout: React.FC<GuestLayoutProps> = (props) => (
    <BasicLayout>
        <GlobalToaster />
        {props.children}
    </BasicLayout>
);
